var webooker_courses_models = webooker_courses_models || {};

(function (ns) {

    // #region CourseRegistrationInvoice - ctor
    ns.CourseRegistrationInvoiceLine = function CourseRegistrationInvoiceLine(courseRegistrationInvoice, lineType, promotion, invoiceLine) {

        this.getCourseRegistrationInvoice = function () { return courseRegistrationInvoice };
        this.lineType = lineType;
        if (promotion) {
            this.membershipID = promotion.membershipID;
            this.promotion = promotion;
            this.owns = promotion.owns;
            if (this.lineType === 'Membership') {
                this.promotion.buy = this.promotion.owns && !!invoiceLine;
            }
        } 
        this.isInInvoice = !!invoiceLine;
        this.invoiceLine = invoiceLine;

        this.isNameEditable = this.lineType === 'ManualAdjustment';
        this.isValueEditable = this.lineType === 'ManualAdjustment';
        
        this.runtimeManualAdjustmentType = 0;
        this.runtimeManualAdjustmentPercentDiscount = 0;

        //CourseFee = 1,
        //Discount = 2,
        //Membership = 3,
        //ManualAdjustment = 4,



        // Membership
        //buy: false
        //description: null
        //discountPct: 5
        //isMandatory: false
        //membershipID: 110
        //name: "Volitelná sleva platná"
        //owns: true
        //price: 0

    };
    // #endregion

    ns.CourseRegistrationInvoiceLine.prototype.toJSON = function () {
        return {
            lineType: this.lineType,
            membershipID: this.membershipID,
            studentMembershipID: !!this.invoiceLine ? this.invoiceLine.studentMembershipID : null,
            buy: this.buy,
            price: this.price,
            name: this.runtimeManualAdjustmentType == 1 
                ? this.name + ' (' + parseFloat(this.percent).toFixed(2) + '%)'
                : this.name
        }
    }

    Object.defineProperty(ns.CourseRegistrationInvoiceLine.prototype, 'isReadonly', {
        enumerable: true, configurable: true,
        get: function () {
            // var parent = this.getCourseRegistrationInvoice();

            switch (this.lineType) {
                case 'CourseFee':
                    return true;
                case 'Membership':
                    return (this.promotion.owns && !this.isInInvoice) ||
                            this.promotion.isMandatory ||
                           !this.isValid;
                case 'ManualAdjustment':
                    return false;
                default:
                    return true;
            }
        }
    });

    Object.defineProperty(ns.CourseRegistrationInvoiceLine.prototype, 'buy', {
        enumerable: true, configurable: true,
        get: function () {
            switch (this.lineType) {
                case 'CourseFee':
                    return true;
                case 'Membership':
                    return (!!this.promotion.buy && !!this.isValid) ||
                           (!!this.promotion.isMandatory && !!this.isValid && !(!!this.promotion.owns && !this.isInInvoice)); 
                case 'ManualAdjustment':
                    return this.promotion.buy;
                case 'Discount':
                    return !!this.promotion.buy ||
                           (!this.promotion.buy && !!this.promotion.owns && ((!this.isInInvoice && !this.promotion.isInInvoice) ||
                                                                             (!!this.isInInvoice && !this.promotion.isInInvoice)));
                default:
                    return false;
            }
        },
        set: function (value) {
            switch (this.lineType) {
                case 'Membership':
                    if (!this.isReadonly) {
                        this.promotion.buy = value;
                    }
                    break;
                case 'ManualAdjustment':
                    this.promotion.buy = value;
                    if (!value)
                    {
                        var parent = this.getCourseRegistrationInvoice();
                        parent.removeManualAdjustmentLine(this);
                    }
                    break;
                default:
                    // Cannot be changed by default
                    break;
            }
        }
    });

    Object.defineProperty(ns.CourseRegistrationInvoiceLine.prototype, 'price', {
        enumerable: true, configurable: true,
        get: function () {
            var parent = this.getCourseRegistrationInvoice();

            switch (this.lineType) {
                case 'CourseFee':
                    return parent.coursePriceSvc.getCourseBasePrice(
                        parent.course,
                        parent.noOfRegisteredAttendances,
                        parent.$courseRegistration.reservedPlaces || 1,
                        !!parent.useAmortizationSchedule);
                case 'Membership':
                    return this.buy
                        ? this.promotion.price
                        : 0;
                case 'Discount':
                    return this.buy
                        ? (this.promotion.promotion ? -(parent.basePrice * this.promotion.promotion.discountPct) / 100 : this.promotion.price)
                        : 0;
                case 'ManualAdjustment':
                    return this.buy
                        ? this.promotion.price
                        : 0;
                default:
                    return 0;
            }
        },
        set: function (value) {
            switch (this.lineType) {
                case 'ManualAdjustment':
                    if (this.buy) {
                        this.promotion.price = value;
                    }
                    break;
            }
        }
    });

    Object.defineProperty(ns.CourseRegistrationInvoiceLine.prototype, 'name', {
        enumerable: true, configurable: true,
        get: function () {
            var parent = this.getCourseRegistrationInvoice();

            switch (this.lineType) {
                case 'CourseFee':
                    return parent.coursePriceSvc.getCourseFeeLineName(
                        parent.course,
                        parent.noOfRegisteredAttendances,
                        parent.useAmortizationSchedule);
                case 'Membership':
                    return this.promotion.name;
                case 'Discount':
                    if (this.promotion.promotion) {
                        return parent.coursePriceSvc.gtDiscountLineStr(this.promotion.name, this.promotion.promotion.discountPct);
                    }
                    return this.promotion.name;
                case 'ManualAdjustment':
                    return this.buy
                        ? this.promotion.name
                        : null;
                default:
                    return this.promotion.name;
            }
        },
        set: function (value) {
            switch (this.lineType) {
                case 'ManualAdjustment':
                    if (this.buy) {
                        this.promotion.name = value;
                    }
                    break;
            }
        }
    });

    Object.defineProperty(ns.CourseRegistrationInvoiceLine.prototype, 'description', {
        enumerable: true, configurable: true,
        get: function () {
            switch (this.lineType) {
                case 'Membership':
                    return this.promotion.description;
                default:
                    return '';
            }
        }
    });

    Object.defineProperty(ns.CourseRegistrationInvoiceLine.prototype, 'isValid', {
        enumerable: true, configurable: true,
        get: function () {
            switch (this.lineType) {
                case 'Membership':
                    if (this.promotion.validFrom) {
                        var parent = this.getCourseRegistrationInvoice();
                        var membershipNow = moment(parent.membershipNow);

                        return moment(this.promotion.validFrom).isSameOrBefore(membershipNow) &&
                               moment(this.promotion.validTo).isSameOrAfter(membershipNow);
                    }
                    else {
                        return this.promotion.isValid;
                    }
                case 'Discount':
                    return (this.promotion.isValid && !!this.price);
                default:
                    return true;
            }
        }
    });

    Object.defineProperty(ns.CourseRegistrationInvoiceLine.prototype, 'isVisible', {
        enumerable: true, configurable: true,
        get: function () {
            switch (this.lineType) {
                case 'Membership':
                    return (!this.promotion.owns && this.isValid) || this.isInInvoice;
                case 'Discount':
                    return (!!this.price || (!this.price && !!this.isInInvoice));
                default:
                    return true;
            }
        }
    });


    Object.defineProperty(ns.CourseRegistrationInvoiceLine.prototype, 'isModified', {
        enumerable: true, configurable: true,
        get: function () {
            switch (this.lineType) {
                case 'CourseFee':
                    return (!this.isInInvoice && this.buy && !!this.price) ||
                           (this.isInInvoice && !this.isValid) ||
                           (!!this.isInInvoice && !!this.buy && this.price !== this.invoiceLine.price);
                case 'Membership':
                    return (!this.isInInvoice && this.buy) ||
                           (!!this.isInInvoice && !this.buy) ||
                           (!!this.isInInvoice && !!this.buy && this.price !== this.invoiceLine.price) ||
                           (!!this.isInInvoice && !!this.buy && this.name !== this.invoiceLine.name);
                case 'ManualAdjustment':
                    return (!!this.isInInvoice && !!this.buy && this.price !== this.invoiceLine.price) ||
                           (!!this.isInInvoice && !!this.buy && this.name !== this.invoiceLine.name) ||
                           (!this.isInInvoice && !!this.buy && !!this.price) ||
                           (!!this.isInInvoice && (!this.buy || !this.price));
                default:
                    return (!this.isInInvoice && this.buy && !!this.price) ||
                           (this.isInInvoice && !this.isValid) ||
                           (!!this.isInInvoice && !!this.buy && this.price !== this.invoiceLine.price) || 
                           (!!this.isInInvoice && !!this.buy && this.name !== this.invoiceLine.name);
            }
        }
    });

    Object.defineProperty(ns.CourseRegistrationInvoiceLine.prototype, 'percent', {
        enumerable: true, configurable: true,
        get: function () {
            return this.runtimeManualAdjustmentPercentDiscount;
        },
        set: function (value) {
            switch (this.lineType) {
                case 'ManualAdjustment':
                    if (this.buy) {
                        this.runtimeManualAdjustmentPercentDiscount = value;
                        var parent = this.getCourseRegistrationInvoice();
                        this.promotion.price = -(parent.basePrice * value) / 100;
                    }
                    break;
            }
        }
    });

})(webooker_courses_models);